import * as types from 'containers/pages/contacts/constants';

const formAddReducer = (contact, action) => {
	switch (action.type) {
		case types.FIRST_NAME:
			return { ...contact, [types.FIRST_NAME]: action.payload };
		case types.LAST_NAME:
			return { ...contact, [types.LAST_NAME]: action.payload };
		case types.COMPANIES:
			return { ...contact, [types.COMPANIES]: action.payload };
		case types.IMAGE:
			return { ...contact, [types.IMAGE]: action.payload };
		case types.IMAGE_RESET:
			return { ...contact, [types.IMAGE]: action.payload };
		case types.EMAIL_WORK:
			return { ...contact, [types.EMAIL_WORK]: action.payload };
		case types.EMAIL_PERSONAL:
			return { ...contact, [types.EMAIL_PERSONAL]: action.payload };
		case types.EMAIL_OTHER:
			return { ...contact, [types.EMAIL_OTHER]: action.payload };
		case types.CONTACT_POSITION:
			return {...contact, [types.CONTACT_POSITION]: action.payload}
		// case types.CONTACT_TYPES:
		// 	return { ...contact, [types.CONTACT_TYPES]: action.payload };
		case types.PHONE_WORK:
			return { ...contact, [types.PHONE_WORK]: action.payload };
		case types.PHONE_MOBILE:
			return { ...contact, [types.PHONE_MOBILE]: action.payload };
		case types.PHONE_OTHER:
			return { ...contact, [types.PHONE_OTHER]: action.payload };
		case types.ADDRESS_WORK:
			return { ...contact, [types.ADDRESS_WORK]: action.payload };
		case types.ADDRESS_WORK_UNIT:
			return {
				...contact,
				[types.ADDRESS_WORK]: { ...contact[types.ADDRESS_WORK], [types.UNIT]: action.payload },
			};
		case types.ADDRESS_WORK_RESET:
			return { ...contact, [types.ADDRESS_WORK]: action.payload };
		case types.ADDRESS_HOME:
			return { ...contact, [types.ADDRESS_HOME]: action.payload };
		case types.ADDRESS_HOME_UNIT:
			return {
				...contact,
				[types.ADDRESS_HOME]: { ...contact[types.ADDRESS_HOME], [types.UNIT]: action.payload },
			};
		case types.ADDRESS_HOME_RESET:
			return { ...contact, [types.ADDRESS_HOME]: action.payload };
		case types.ADDRESS_OTHER:
			return { ...contact, [types.ADDRESS_OTHER]: action.payload };
		case types.ADDRESS_OTHER_UNIT:
			return {
				...contact,
				[types.ADDRESS_OTHER]: { ...contact[types.ADDRESS_OTHER], [types.UNIT]: action.payload },
			};
		case types.ADDRESS_OTHER_RESET:
			return { ...contact, [types.ADDRESS_OTHER]: action.payload };
		case types.LANGUAGES:
			return { ...contact, [types.LANGUAGES]: action.payload };
		case types.NOTE:
			return { ...contact, [types.NOTE]: action.payload };
		case types.NOTE_RESET:
			return { ...contact, [types.NOTE]: '' };
		case types.RESET:
			return action.payload;
		case types.CONTACT_CONVERT:
			return action.payload;
		default:
			return contact;
	}
};

export default formAddReducer;
